import script from "./AddViolation.vue?vue&type=script&setup=true&lang=js"
export * from "./AddViolation.vue?vue&type=script&setup=true&lang=js"

import "./AddViolation.vue?vue&type=style&index=0&id=9c376b30&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c376b30"]])

export default __exports__